import { render, staticRenderFns } from "./GalleryCard.vue?vue&type=template&id=79ee7310&scoped=true&"
import script from "./GalleryCard.vue?vue&type=script&lang=js&"
export * from "./GalleryCard.vue?vue&type=script&lang=js&"
import style0 from "./GalleryCard.vue?vue&type=style&index=0&id=79ee7310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ee7310",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
